// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;Who made heaven and earth,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;the sea and all that is in them;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;who keeps his promise for ever;<br> </p> </div></div>";
// Exports
module.exports = code;